import { SelectItem } from '../../../main/components'
import { IconNameType } from '../../../main/components/icon'

export enum QuoteNodeChartTypes {
  candlesticksimple = 'candlesticksimple',
  candlestick = 'candlestick',
  line = 'line',
  ohlc = 'ohlc',
  heikinashi = 'heikinashi',
  hollowcandlestick = 'hollowcandlestick',
}

export enum QuoteUrlChartTypes {
  cs = 'cs',
  c = 'c',
  l = 'l',
  o = 'o',
  ha = 'ha',
  hc = 'hc',
}

export const QuoteShortToLongType = {
  [QuoteUrlChartTypes.cs]: QuoteNodeChartTypes.candlesticksimple,
  [QuoteUrlChartTypes.c]: QuoteNodeChartTypes.candlestick,
  [QuoteUrlChartTypes.l]: QuoteNodeChartTypes.line,
  [QuoteUrlChartTypes.o]: QuoteNodeChartTypes.ohlc,
  [QuoteUrlChartTypes.ha]: QuoteNodeChartTypes.heikinashi,
  [QuoteUrlChartTypes.hc]: QuoteNodeChartTypes.hollowcandlestick,
} as const

export const QuoteLongToShortType = {
  [QuoteNodeChartTypes.candlesticksimple]: QuoteUrlChartTypes.cs,
  [QuoteNodeChartTypes.candlestick]: QuoteUrlChartTypes.c,
  [QuoteNodeChartTypes.line]: QuoteUrlChartTypes.l,
  [QuoteNodeChartTypes.ohlc]: QuoteUrlChartTypes.o,
  [QuoteNodeChartTypes.heikinashi]: QuoteUrlChartTypes.ha,
  [QuoteNodeChartTypes.hollowcandlestick]: QuoteUrlChartTypes.hc,
} as const

export const FREE_TYPES = ['candlesticksimple', 'candlestick', 'line']

export const DEFAULT_TYPES = [
  { icon: 'candleBarBasic', value: QuoteNodeChartTypes.candlestick, label: 'Candle' },
  { icon: 'lineChartType', value: QuoteNodeChartTypes.line, label: 'Line' },
  { icon: 'ohlcChartType', value: QuoteNodeChartTypes.ohlc, label: 'OHLC' },
  { icon: 'candleBarHollow', value: QuoteNodeChartTypes.hollowcandlestick, label: 'Hollow Candle' },
  { icon: 'candleBarHeikinAshi', value: QuoteNodeChartTypes.heikinashi, label: 'Heikin Ashi' },
]

export type TypeBaseOption = SelectItem<QuoteNodeChartTypes> & {
  icon: IconNameType
  href: string
}
